import axiosIns from '@/api/axios';
import axiosInsAcademy from '@/api/axios-ugems-academy';

export const tabToLearningType = {
    structured: 'structured_learning',
    social: 'social_learning',
    experiential: 'experiential_learning',
};

export const fetchTNAPeriod = async () => {
    try {
        const response = await axiosIns.get(`tna-period`);
        return response.data;
    } catch (error) {
        console.error('Error fetching TNA period:', error);
        return [];
    }
}

export const fetchSummaryData = async (payload) => {
    try {
        const response = await axiosIns.get(`tna/summary`, { params: payload });
        return response.data.data;
    } catch (error) {
        console.error('Error fetching summary data:', error);
        return {};
    }
}

export const fetchDataByTab = async (payload) => {
    try {
        const response = await axiosIns.get('tna/learnings', {
            params: payload,
        });
        return response?.data?.data ?? response?.data ?? [];
    } catch (error) {
        console.error('Error fetching data:', error);
        return [];
    }
};

export const fetchDetailStructuredLearningByCompetency = async (competencyId, tnaId) => {
    try {
        const response = await axiosIns.get(
            `tna/structured-learnings/by-competency?competency_id=${competencyId}${tnaId ? `&tna_id=${tnaId}` : ""}`
        );
        return response.data.data;
    } catch (error) {
        console.error("Error fetching structured learning detail by competency:", error);
        return null;
    }
};

export const fetchDetailStructuredLearning = async (id) => {
    try {
        const response = await axiosIns.get(`tna/structured-learnings/detail/${id}`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching structured learning detail:', error);
        return null;
    }
};

export const fetchDetailSocialLearning = async (id) => {
    try {
        const response = await axiosIns.get(`tna/social-learnings/detail/${id}`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching social learning detail:', error);
        return null;
    }
};

export const fetchDetailExperientialLearning = async (id) => {
    try {
        const response = await axiosIns.get(`tna/experiential-learnings/detail/${id}`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching experiential learning detail:', error);
        return null;
    }
};

export const fetchSubmitTNA = async (args) => {
    try {
        const learningType = tabToLearningType[args.activeTab] || '';
        const mappedTrainingPlan = (args.trainingPlan || []).map(item => ({
            training_id: item.id,
            training_mapping_id: item.training_mapping_id || null,
            year: item.year || null,
            mandatory: item.mandatory,
            remarks: item.remarks || undefined,
        }));
        const itemIds = args.items.map(i => i.id) || [];
        const idsPayload = mappedTrainingPlan.length > 0 ? mappedTrainingPlan : itemIds;

        const payload = {
            learning_type: learningType,
            // Use 'id' key for experiential_learning, 'ids' for others
            ...(learningType === 'experiential_learning'
                ? { id: itemIds[0] }
                : { ids: idsPayload }
            )
        }
        const response = await axiosIns.post(`tna/submit?learning_type=${payload.learning_type}`, payload);
        return response.data;
    } catch (error) {
        console.error('Error submitting TNA data:', error);
        throw error;
    }
}

export const fetchSubordinatesLearning = async (params) => {
    try {
        const response = await axiosIns.get('tna/subordinates', { params });
        return response.data.data;
    } catch (error) {
        console.error('Error fetching subordinates learning data:', error);
        return [];
    }
};

export const fetchApproveTNA = async (payload) => {
    try {
        const response = await axiosIns.post(`tna/approve?learning_type=${payload.learning_type}`, payload);
        return response.data;
    } catch (error) {
        console.error('Error approving TNA data:', error);
        throw error;
    }
}

export const fetchSubmitTNASocial = async (payload) => {
    try {
        const response = await axiosIns.post(`tna/social-learnings/add`, payload);
        return response.data;
    } catch (error) {
        console.error('Error submitting TNA social data:', error);
        throw error;
    }
}

export const fetchAddNewProjectExperiential = async (formData) => {
    try {
        const response = await axiosIns.post(`tna/experiential-learnings/add`, formData);
        return response.data;
    } catch (error) {
        console.error('Error adding new experiential project:', error);
        throw error;
    }
}

export const downloadCourseMappingTemplate = async () => {
    try {
        const response = await axiosInsAcademy.get('/training-mapping/bulk-download-template', {
            responseType: 'blob'
        });
        return response;
    } catch (error) {
        console.error('Error downloading course mapping template:', error);
        throw error;
    }
};

export const uploadCourseMapping = async (formData) => {
    try {
        const response = await axiosInsAcademy.post('/training-mapping/bulk-create', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (error) {
        console.error('Error uploading course mapping:', error);
        throw error;
    }
};

export const downloadTrainingHistoryTemplate = async () => {
    try {
        const response = await axiosIns.get('/idp/history/download-template', {
            responseType: 'blob'
        });
        return response;
    } catch (error) {
        console.error('Error downloading training history template:', error);
        throw error;
    }
};

export const uploadTrainingHistory = async (formData) => {
    try {
        const response = await axiosIns.post('/idp/history', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (error) {
        console.error('Error uploading training history:', error);
        throw error;
    }
};
